var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-map-tools"},[_c('o-map-zoom-tool-group')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }